/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Tab,
  Tabs,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../../Utils/Interceptor/ApiMiddleware";
import AddCompany from "../../components/Composables/AddCompany";
import dayjs from "dayjs";
import DeleteConfirmationDialog from "../../components/Composables/DeleteDialogs";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";

function CompanyDescription() {
  const [backbutton, setbackbutton] = useState(false);
  const [selectedTab, setSelectedTab] = useState("CompanyInfo");
  const [companyDetails, setCompanyDetails] = useState({
    basicDetails: {},
    otherDetails: {},
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [branchDetails, setBranchDetails] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openBranch, setOpenBranch] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const companyId = location.state?.id;

  const getCompanyDetails = async () => {
    setLoading(true);
    try {
      const response = await API.get(`/company/company-details/${companyId}`);
      if (response?.data?.success) {
        const basicDetails = {
          Name: response.data.data["Basic Details"].Name || "",
          State: response.data.data["Basic Details"].State || "",
          City: response.data.data["Basic Details"].City || "",
          "Contact Number":
            response.data.data["Basic Details"]["Contact Number"] || "",
          Address:
            `${response.data.data["Basic Details"].Address}, ${response.data.data["Basic Details"].City}, ${response.data.data["Basic Details"].State}, ${response.data.data["Other Details"].ZIP}` ||
            "",
          "Website Link":
            response.data.data["Basic Details"]["Website Link"] || "",
          Branches: response.data.data["Basic Details"].Branches || "",
          "Created On": response.data.data["Basic Details"]["Created On"] || "",
          "Additional Info":
            response.data.data["Basic Details"]["Additional Info"] || "",
        };

        setCompanyDetails({
          basicDetails: basicDetails || {},
          otherDetails: response.data.data["Other Details"] || {},
        });
      }
    } catch (error) {
      console.error("Error fetching company details ", error);
    } finally {
      setLoading(false);
    }
  };

  const getBranchDetails = async () => {
    try {
      const response = await API.get(
        `/company/company-branch-details/${companyId}`
      );
      if (response?.data?.success) {
        setBranchDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching branch details ", error);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleDialog = () => {
    setOpenDialog(true);
  };

  const deleteCompanyFunction = async () => {
    try {
      const response = await API.post(`/company/delete-company/${companyId}`);
      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Company deleted successfully",
          severity: "success",
        });
        setTimeout(() => {
          handleClose();
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      console.error("Error deleting company:", error);
      setSnackbar({
        open: true,
        message: "Error deleting company",
        severity: "error",
      });
    }
  };

  const handleDeleteConfirmation = async (confirmed) => {
    setOpenDialog(false);
    if (confirmed) {
      try {
        await deleteCompanyFunction();
      } catch (error) {
        console.error("Error deleting company:", error);
      }
    }
  };

  const handleAddBranch = async () => {
    setOpenBranch(true);
  };

  useEffect(() => {
    if (companyId) {
      getCompanyDetails();
      getBranchDetails();
    }
  }, [companyId]);

  return (
    <Box
      sx={{
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFF",
          padding: "16px",
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          height: "100%",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
                paddingBottom: "16px",
                // marginBottom: "20px",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <Button
                startIcon={
                  <ChevronLeftOutlinedIcon
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                sx={{
                  "& .MuiButton-startIcon": backbutton
                    ? { marginRight: "4px !important" }
                    : { margin: "0px" },
                }}
                style={
                  backbutton
                    ? {
                        backgroundColor: "#3F95EA",
                        color: "white",
                        height: "24px",
                        fontSize: "12px",
                        textTransform: "none",
                      }
                    : {
                        backgroundColor: "#E7E7E7",
                        color: "#1A1A1A",
                        minWidth: "24px",
                        height: "24px",
                        padding: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                }
                onMouseEnter={() => setbackbutton(true)}
                onMouseLeave={() => setbackbutton(false)}
                onClick={() => navigate(-1)}
              >
                {backbutton ? "Back" : ""}
              </Button>
              <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
                Company Details
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
                <Box
                  sx={{
                    width: "100px",
                    height: "100px",
                    backgroundColor: "#E3F2FD",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {companyDetails?.otherDetails?.Logo ? (
                    <img
                      src={`${process.env.REACT_APP_BASEURL}${companyDetails?.otherDetails?.Logo}`}
                      alt="Company Logo"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  ) : (
                    <ApartmentIcon
                      sx={{ fontSize: "100px", color: "#979797" }}
                    />
                  )}
                </Box>

                <Box>
                  <Typography fontSize={"20px"} fontWeight={600}>
                    {companyDetails.basicDetails.Name}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                    {companyDetails.basicDetails.City},{" "}
                    {companyDetails.basicDetails.State}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  sx={{ marginRight: "16px" }}
                  startIcon={<ModeEditIcon />}
                  onClick={handleOpen}
                >
                  Edit
                </Button>
                <Button
                  startIcon={<DeleteOutlineOutlinedIcon />}
                  variant="outlined"
                  color="error"
                  sx={{ alignSelf: "flex-start" }}
                  onClick={handleDialog}
                >
                  <Typography sx={{ fontSize: "12px", fontWeight: "400" }}>
                    DELETE
                  </Typography>
                </Button>
              </Box>
            </Box>

            {/* Tabs */}
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => setSelectedTab(newValue)}
              sx={{
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                // margin: "20px 0",
              }}
            >
              <Tab
                value="CompanyInfo"
                label="Company Info"
                sx={{ fontWeight: "500", fontSize: "14px" }}
              />
            </Tabs>

            {selectedTab === "CompanyInfo" && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  gap: "16px",
                  height: "calc(100% - 250px)",
                }}
              >
                {/* Basic Information */}
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid rgba(115, 119, 145, 0.08)",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "4px 4px 0 0",
                      padding: "14px 20px",
                      backgroundColor: "rgba(63, 149, 234, 0.20)",
                      fontSize: "14px",
                      fontWeight: "600",
                      flexShrink: 0,
                    }}
                  >
                    Basic Details
                  </Box>
                  <CardContent
                    sx={{
                      padding: "16px 20px",
                      overflowY: "auto",
                      flexGrow: 1,
                    }}
                  >
                    {Object.entries(companyDetails.basicDetails).map(
                      ([key, value]) => (
                        <Box
                          key={key}
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                            marginBottom: "8px",
                          }}
                        >
                          <Typography
                            sx={{
                              textTransform: "capitalize",
                              fontWeight: "400",
                              fontSize: "14px",
                              color: "rgba(0, 0, 0, 0.60)",
                              minWidth: "160px",
                              maxWidth: "160px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {key}
                          </Typography>

                          {key === "Website Link" && value ? (
                            <Typography
                              component="a"
                              href={
                                value.startsWith("http")
                                  ? value
                                  : `https://${value}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "#1976d2",
                                textDecoration: "underline",
                                flex: 1,
                                wordBreak: "break-word",
                              }}
                            >
                              {value}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "rgba(0, 0, 0, 0.87)",
                                flex: 1,
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {value
                                ? key === "Created On"
                                  ? dayjs(value).format("DD/MM/YYYY")
                                  : value
                                : "NA"}
                            </Typography>
                          )}
                        </Box>
                      )
                    )}
                  </CardContent>
                </Card>

                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid rgba(115, 119, 145, 0.08)",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%",
                    overflow: "hidden",
                    textAlign: branchDetails.length ? "left" : "center",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "4px 4px 0 0",
                      padding: "14px 20px",
                      backgroundColor: "rgba(63, 149, 234, 0.20)",
                      fontSize: "14px",
                      fontWeight: "600",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    Branches Details
                    <Button
                      disabled={
                        !companyDetails.otherDetails["Is Branch Managed"]
                      }
                      sx={{
                        backgroundColor: !companyDetails.otherDetails[
                          "Is Branch Managed"
                        ]
                          ? "rgba(63, 149, 234, 0.20)"
                          : "#2196F3",
                        padding: "6px 8px",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={handleAddBranch}
                    >
                      <AddIcon sx={{ fontSize: 20, marginRight: "8px" }} />
                      <Typography sx={{ fontSize: "14px" }}>
                        ADD BRANCH
                      </Typography>
                    </Button>
                  </Box>
                  <CardContent
                    sx={{
                      padding: "16px 20px",
                      overflowY: "auto",
                      flexGrow: 1,
                    }}
                  >
                    {branchDetails.length > 0 ? (
                      branchDetails.map((branch) => (
                        <Box
                          key={branch.id}
                          display="flex"
                          alignItems="center"
                          gap={2}
                          sx={{
                            cursor: "pointer",
                            mb: "12px",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                          onClick={() =>
                            navigate(`/branch-details/${branch.id}`)
                          }
                        >
                          {/* Company Image */}
                          <Box
                            component="img"
                            src={
                              `${process.env.REACT_APP_BASEURL}${companyDetails?.otherDetails?.Logo}` ||
                              "default_logo.png"
                            }
                            alt={branch.company_name}
                            sx={{
                              width: 48,
                              height: 48,
                              borderRadius: "8px",
                              objectFit: "cover",
                            }}
                          />

                          {/* Company Name & Address */}
                          <Box
                            padding={"8px 0"}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={"12px"}
                            >
                              <Typography fontSize="14px" fontWeight="400">
                                {branch.branch_name}
                              </Typography>
                              {branch.is_internal > 0 && (
                                <Typography
                                  fontSize="12px"
                                  fontWeight="500"
                                  padding="0.25rem 0.5rem"
                                  border="1px solid #99C4E2"
                                  borderRadius="0.25rem"
                                  color="#006CB7"
                                >
                                  Default
                                </Typography>
                              )}
                            </Box>

                            <Typography
                              fontSize="12px"
                              fontWeight="400"
                              color="text.secondary"
                            >
                              {branch.city}, {branch.state}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Typography
                        fontSize="14px"
                        fontWeight="500"
                        color="text.secondary"
                      >
                        No Branches for this company
                      </Typography>
                    )}
                  </CardContent>
                </Card>

                {/* Recent Activities */}
                {/* <Card
              elevation={0}
              sx={{
                borderRadius: "4px",
                border: "1px solid rgba(115, 119, 145, 0.08)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "100%",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  borderRadius: "4px 4px 0 0",
                  padding: "20px 20px",
                  backgroundColor: "rgba(63, 149, 234, 0.20)",
                  fontSize: "14px",
                  fontWeight: "600",
                  // display: "flex",
                  // justifyContent: "space-between",
                  flexShrink: 0,
                }}
              >
                Recent Activities
              </Box>
              <CardContent
                sx={{
                  padding: "16px 20px",
                  overflowY: "auto",
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  color="text.secondary"
                >
                  No recent activities
                </Typography>
              </CardContent>
            </Card> */}

                {openBranch && (
                  <AddCompany
                    open={openBranch}
                    branchId={0}
                    companyId={companyId}
                    handleClose={() => setOpenBranch(false)}
                  />
                )}
              </Box>
            )}
          </>
        )}
      </Box>
      <AddCompany
        open={open}
        handleClose={handleClose}
        companyId={companyId}
        companyDetails={companyDetails}
      />
      <DeleteConfirmationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleDeleteConfirmation}
        pageName={"company"}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Box>
  );
}

export default CompanyDescription;
